import { render } from "./Photo.vue?vue&type=template&id=95ddb954&ts=true"
import script from "./Photo.vue?vue&type=script&lang=ts"
export * from "./Photo.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__